import { useSelector } from 'react-redux';
import { State } from 'store/types';
import { useIsLoggedIn } from 'hooks/auth';

export const useIsAffiliateLinkSharingEnabled = () => {
  const isLoggedIn = useIsLoggedIn();
  const isAffiliateLinkSharingEnabled = useSelector(
    (state: State) =>
      state.remoteConfig?.configs?.exploreAffiliateLinkSharing?.enabled
  );
  return isLoggedIn && !!isAffiliateLinkSharingEnabled;
};
